// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import {
  CHANGE_OPEN_PANEL,
  CLEAR_PROJECT_SUMMARY,
  FETCH_PROJECT_ERROR,
  FETCH_PROJECT_SUCCESS,
  FETCHING_PROJECT,
  PROJECT_SUMMARY_MODAL_CLOSE,
  PROJECT_SUMMARY_MODAL_OPEN,
  UPDATE_COMPANIES,
  UPDATE_HIGHLIGHTED_PATHS,
  UPDATE_MODAL_ERROR,
  UPDATE_MODAL_MESSAGE,
  UPDATE_MODAL_PATH_SET,
  UPDATE_PATHS,
  UPDATE_PROJECT_FILTER,
  UPDATE_PROJECT_SETTINGS,
  UPDATE_PROJECT_SORT,
  UPDATE_VISIBLE_PATHS,
} from './types'

export const changeOpenPanel = (openPanel = '') => ({
  type: CHANGE_OPEN_PANEL,
  openPanel,
})

export const clearProjectSummary = () => ({
  type: CLEAR_PROJECT_SUMMARY,
})

export const fetchProjectError = error => ({
  type: FETCH_PROJECT_ERROR,
  error,
})

export const fetchProjectSuccess = projectMeta => ({
  type: FETCH_PROJECT_SUCCESS,
  projectMeta,
})

export const fetchingProject = () => ({
  type: FETCHING_PROJECT,
  isFetching: true,
})

export const projectSummaryModalClose = () => ({
  type: PROJECT_SUMMARY_MODAL_CLOSE,
})

export const projectSummaryModalOpen = (modalTemplate, modalPathsSet = []) => ({
  type: PROJECT_SUMMARY_MODAL_OPEN,
  modalTemplate,
  modalPathsSet,
})

export const updateCompanies = companies => ({
  type: UPDATE_COMPANIES,
  companies,
})

// highlightedPaths is the new set of paths which are highlighted after this
// action is complete.
export const updateHighlightedPaths = highlightedPaths => ({
  type: UPDATE_HIGHLIGHTED_PATHS,
  highlightedPaths,
})

export const updateModalError = error => ({
  type: UPDATE_MODAL_ERROR,
  error,
})

export const updateModalMessage = modalMessage => ({
  type: UPDATE_MODAL_MESSAGE,
  modalMessage,
})

// modalPathsSet is the new set of modal path ids which should display
// in the project summary modal
export const updateModalPathSet = (highlightedPaths, modalPathsSet) => ({
  type: UPDATE_MODAL_PATH_SET,
  highlightedPaths,
  modalPathsSet,
})

export const updatePaths = paths => ({
  type: UPDATE_PATHS,
  paths,
})

export const updateProjectFilter = ({ filterInput, filterSelect, filterCheckbox }) => ({
  type: UPDATE_PROJECT_FILTER,
  filterInput,
  filterSelect,
  filterCheckbox,
})

export const updateProjectSettings = settings => ({
  type: UPDATE_PROJECT_SETTINGS,
  settings,
})

export const updateProjectSort = ({ sortAsc, sortCol }) => ({
  type: UPDATE_PROJECT_SORT,
  sortAsc,
  sortCol,
})

// visiblePathIds is the new set of paths which are to be rendered in the UI
// NOTE - this will determine which paths from the full paths set should be rendered.
export const updateVisiblePathIds = (visiblePathIds = []) => ({
  type: UPDATE_VISIBLE_PATHS,
  visiblePathIds,
})
